angular.module('nv.singleStudent').component('studentRegentsPanelTable', {
  // tslint:disable-next-line:max-line-length
  template: require('./student-regents-panel-table.html'),
  bindings: {
    student: '<',
    school: '<',
    studentSupports: '<',
    schedExamsNotInStars: '<',
    schedExamsWithNoSupport: '<',
    hideSchedInStars: '<',
    isRestricted: '<',
    saveStudent: '&',
  },
  controller: 'StudentRegentsPanelTableCtrl',
});
